var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.value},domProps:{"textContent":_vm._s(_vm.$t('goBackUp.label'))},on:{"click":function($event){$event.preventDefault();return _vm.$vuetify.goTo(_vm.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }